module.exports = __webpack_public_path__ + "img/24.692935e1.jpg";